import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast, Toaster } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [params] = useSearchParams();
    const next = params.get("next") || "/";
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const u = await login(email, password);
            toast.success("Welcome back");
            if (u.role === "admin" || u.role === "editor") nav("/admin");
            else if (u.role === "doctor") nav("/doctor");
            else nav(next);
        } catch (e) {
            toast.error(e.response?.data?.detail || "Login failed");
        } finally { setBusy(false); }
    };

    return (
        <div className="max-w-md mx-auto px-4 py-20" data-testid="login-page">
            <Toaster position="top-center" />
            <div className="text-center mb-10">
                <div className="label-eyebrow text-sky-700">Welcome back</div>
                <h1 className="font-serif text-4xl text-stone-900 mt-2">Sign in</h1>
            </div>
            <form onSubmit={submit} className="bg-white border border-stone-200 p-8 space-y-5">
                <div>
                    <Label className="text-xs uppercase tracking-widest text-stone-500">Email</Label>
                    <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none border-stone-300 mt-1" required data-testid="login-email" />
                </div>
                <div>
                    <Label className="text-xs uppercase tracking-widest text-stone-500">Password</Label>
                    <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none border-stone-300 mt-1" required data-testid="login-password" />
                    <div className="text-right mt-1">
                        <Link to="/forgot-password" className="text-[11px] text-sky-700 hover:underline" data-testid="forgot-password-link">Forgot password?</Link>
                    </div>
                </div>
                <Button type="submit" disabled={busy} className="rounded-none w-full bg-sky-700 hover:bg-sky-800 text-stone-50 py-6" data-testid="login-submit">
                    {busy ? "Signing in…" : "Sign in"}
                </Button>
                <p className="text-xs text-center text-stone-500">No account? <Link to="/register" className="text-sky-700 underline">Create one</Link></p>
                <p className="text-xs text-center text-stone-500">Are you a doctor? <Link to="/enroll-doctor" className="text-sky-700 underline">Enroll here</Link></p>
            </form>
        </div>
    );
}
